import { Box, Divider, IconButton, Modal, Skeleton, Typography, useTheme } from '@mui/material';
import { useGetHotelIntegrationById } from '../../queries';
import { useSnackBar } from '@frontend/features/common/components/SnackBarContext';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { FormCreateOrEditHotelIntegration } from '../FormCreateOrEditHotelIntegration';
import { HotelSupplier } from '@bandido/shared/interfaces';

interface EditHotelIntegrationModalProps {
  open: boolean;
  onClose: () => void;
  hotelIntegrationId: string | null;
  suppliers: HotelSupplier[];
}

export const EditHotelIntegrationModal = ({ open, onClose, hotelIntegrationId, suppliers }: EditHotelIntegrationModalProps) => {
  const { data, isLoading, error, isError } = useGetHotelIntegrationById(hotelIntegrationId ?? '');
  const { addToast } = useSnackBar();
  const { t } = useTranslation();
  const theme = useTheme();
  
  useEffect(() => {
    if (isError && error) {
      addToast({
        message: t('hotelIntegrations.edit.loadItemError'),
        color: 'error',
      });
    }
  }, [isError, error, addToast, t]);
  
  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('hotelIntegrations.edit.title')}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: theme.shadows[1],
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box display="flex" gap={2}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={1}>
            <Typography id="edit-hotel-integrations-modal-title" variant="h6" component="h2">
              {t('hotelIntegrations.edit.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        {isLoading && <Skeleton height={80} variant="rounded" animation="wave" />}
        {data && <FormCreateOrEditHotelIntegration onClose={onClose} integrationToEdit={data} suppliers={suppliers} />}
      </Box>
    </Modal>
  );
};
